import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { DeliveryRoadmap, Roadmap } from "../state/types"

export const useRoadmapActions = () => {
    const saveActions = useSaveActions()

    const saveRoadmap = (roadmap: Roadmap) => {
        const { save } = saveActions()
        return save(TableName.ROADMAPS, roadmap) as Promise<Roadmap>
    }

    const removeRoadmap = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.ROADMAPS, id)
    }

    const removeRoadmaps = (ids: string[]) => {
        const { removeMultiple } = saveActions()
        return removeMultiple(TableName.ROADMAPS, ids)
    }

    const saveDeliveryRoadmaps = (deliveryRoadmaps: DeliveryRoadmap[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.DELIVERY_ROADMAPS, deliveryRoadmaps) as Promise<DeliveryRoadmap[]>
    }

    const removeDeliveryRoadmap = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.DELIVERY_ROADMAPS, id)
    }

    const removeDeliveryRoadmaps = (ids: string[]) => {
        const { removeMultiple } = saveActions()
        return removeMultiple(TableName.DELIVERY_ROADMAPS, ids)
    }

    return {
        saveRoadmap,
        removeRoadmap,
        removeRoadmaps,
        saveDeliveryRoadmaps,
        removeDeliveryRoadmap,
        removeDeliveryRoadmaps
    }
}
